import { gridDelay, gridTransLength, gridTransTime, HomeTsProjGridSnapTiming, HomeTsProjTotalTransLength } from "./transitionVariables"


// 0 positioning
// 1 adjustment
// 2 is tablet
// 3 is B view
export const upperHorizVariants = {
    initial:(i)=>({
        transform: `scale(0, 1) translate3d(0, ${i[0]}px, 0)`,
        background: 'var(--light-color)'
    }), animate:(i)=>({
        transform: `scale(0, 1) translate3d(0, ${i[0]}px, 0)`,
        background: 'var(--grid-lines)'
    }), exit: (i)=>({
        transform: `scale(0, 1) translate3d(0, ${i[0]}px, 0)`,
    }), projExit:(i)=>({
        transform: [
            `scale(0, 1) translate3d(0, ${i[0]}px, 0)`,
            `scale(1, 1) translate3d(0, ${i[0]}px, 0)`,
            `scale(1, 1) translate3d(0, ${i[1]}px, 0)`
        ],
        background: 'var(--grid-lines)',
        transition: {
            duration: i[3] ? gridTransLength : i[2] ? HomeTsProjTotalTransLength: 2.5,
            delay: i[3] ? gridDelay : 0,
            times: i[3] ? [0,  gridTransTime/gridTransLength, 1] : i[2] ? [0, HomeTsProjGridSnapTiming/HomeTsProjTotalTransLength, 1] : [0, 0.6, 1],
            ease: i[3] ? [[0.87, 0, 0.13, 1], [0.87, 0, 0.13, 1], [0.87, 0, 0.13, 1]] : [[0.85, 0, 0.15, 1],[0.16, 1, 0.3, 1], [0.16, 1, 0.3, 1]],
            background: {
                ease: [0.16, 1, 0.3, 1],
                duration: i[2] ?  HomeTsProjTotalTransLength : 2.5
            }
        }
    })
}

export const sideVertVariants = {
    initial: (i) => ({
        transform: `scale(1, 0) translate3d(${i[0]}px, 0, 0)`,
        background: 'var(--light-color)'
    }), animate: (i) => ({
        transform: `scale(1, 0) translate3d(${i[0]}px, 0, 0)`,
        background: 'var(--grid-lines)'
    }), exit: (i) => ({
        transform: `scale(1, 0) translate3d(${i[0]}px, 0, 0)`
    }), projExit: (i) => ({
        // transform: [`scale(1, 0) translate3d(0, ${i[0]}px, 0)`, `scale(1, 1) translate3d(${i[0]}px, 0, 0)`, `scale(1, 1) translate3d(${i[1]}px, 0, 0)`],
        transform: [`scale(1, 0) translate3d(${i[0]}px, 0, 0)`, `scale(1, 1) translate3d(${i[0]}px, 0, 0)`, `scale(1, 1) translate3d(${i[1]}px, 0, 0)`],
        background: 'var(--grid-lines)',
     transition: {
            duration: i[3] ? gridTransLength: i[2] ? HomeTsProjTotalTransLength: 2.5,
            delay: i[3] ? gridDelay : 0,
            times: i[3] ? [0, gridTransTime/gridTransLength, 1] : i[2] ? [0, HomeTsProjGridSnapTiming/HomeTsProjTotalTransLength, 1] : [0, 0.6, 1],
            ease: i[3] ? [[0.87, 0, 0.13, 1], [0.87, 0, 0.13, 1], [0.87, 0, 0.13, 1]] : [[0.85, 0, 0.15, 1],[0.16, 1, 0.3, 1], [0.16, 1, 0.3, 1]],
            background: {
                ease: [0.16, 1, 0.3, 1],
                duration: i[2] ?  HomeTsProjTotalTransLength : 2.5
            }
        }
    })
}